import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Megaphone } from "lucide-react";
import { api } from "../../lib/api";

export default function AdminAnnouncementEditor({ headers }) {
  const [f, setF] = useState({ message: "", link_url: "", tone: "red", active: false });
  useEffect(() => {
    api.get("/admin/announcements/manual", { headers }).then(({ data }) => setF({ message: data.message || "", link_url: data.link_url || "", tone: data.tone || "red", active: !!data.active })).catch(() => {});
  }, [headers]);
  const save = async () => {
    try { await api.put("/admin/announcements/manual", f, { headers }); toast.success(f.active ? "Manual strip is live." : "Manual strip saved (off)."); }
    catch { toast.error("Save failed."); }
  };
  return (
    <div className="border border-zinc-300 p-4 space-y-2" data-testid="announcement-editor">
      <div className="label-eyebrow inline-flex items-center gap-2"><Megaphone size={12} /> Manual announcement strip</div>
      <p className="text-xs text-zinc-600">Optional extra message. Published rescues with "Show on strip" turned on appear automatically.</p>
      <input value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} placeholder="Message" className="w-full border border-zinc-300 px-2 py-1.5 text-sm" data-testid="announcement-message" />
      <div className="flex flex-wrap gap-2 items-center">
        <input value={f.link_url} onChange={(e) => setF({ ...f, link_url: e.target.value })} placeholder="Link (e.g. /urgent-rescues/...)" className="flex-1 min-w-[200px] border border-zinc-300 px-2 py-1.5 text-sm" data-testid="announcement-link" />
        <select value={f.tone} onChange={(e) => setF({ ...f, tone: e.target.value })} className="border border-zinc-300 px-2 py-1.5 text-sm" data-testid="announcement-tone">
          <option value="red">Red</option><option value="amber">Amber</option><option value="neutral">Black</option>
        </select>
        <label className="text-sm flex items-center gap-1"><input type="checkbox" checked={f.active} onChange={(e) => setF({ ...f, active: e.target.checked })} data-testid="announcement-active" /> On</label>
        <button onClick={save} className="btn-danger" data-testid="announcement-save">Save</button>
      </div>
    </div>
  );
}
